import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TCardId } from '../../../../../../../../types/types';
import { cardSetName } from '../../../../../../../../rest/effects/card/card/cardSetName';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { getHint } from '../../../../../../hints/store/hints/selectors/getHint';
import { EHintKey, EHintStatus } from '../../../../../../hints';
import { setHintCanShow } from '../../../../../../hints/effects/setHintCanShow';
import { editedNameCardIdSet } from '../../../../../../main/kanbanView/store/actions/editedNameCardIdSet';

export const onSave = (
    cardId: TCardId,
    name: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        dispatch(cardSetName(cardId, name));
        dispatch(segmentTrackAction(SegmentCardEvent.CHANGE_NAME));
        const hint = getHint(getState(), EHintKey.KANBAN_CARD_RENAME);
        if (hint.status === EHintStatus.NOT_SHOWN) {
            dispatch(setHintCanShow(EHintKey.KANBAN_CARD_RENAME, true));
            dispatch(editedNameCardIdSet(cardId));
        }
    };
    return action;
};
